<script>
import _debounce from "lodash/debounce";
import pagination from "@/mixins/pagination";
import tableSearch from "@/mixins/tableSearch";
import CommonTableComponent from "@/components/table.vue";
import apiEndpoints from "@/services/apiEndpoints";

export default {
  components: {
    CommonTableComponent
  },
  props: {
    qualifications_by_work_order: {
      type: Array,
      default: () => [],
    },
    isUpdate: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  mixins: [pagination, tableSearch],
  data() {
    return {
      qualifications: [],
    };
  },
  methods: {
    updateValue () {
      let dataSelected = this.qualifications.filter(qualification => !!qualification.number_of_staffs && qualification.number_of_staffs > 0);
      this.$emit("dataSelected", [...dataSelected]);
      this.$bvModal.hide("choose-qualifications");
    },
    setData() {
      let qualificationMapping = [];
      this.zz_qualifications.forEach(zz_qualification => {
        let matchQualification = this.qualifications_by_work_order.find(qualification => qualification.id === zz_qualification.id);
        qualificationMapping.push({
          id: zz_qualification.id,
          qualification: zz_qualification.qualification,
          number_of_staffs: matchQualification ? matchQualification.number_of_staffs : null,
        });
      });
      this.qualifications = [...qualificationMapping];
    },
    formatterPositiveNumber(value){
      return Math.abs(value)
    }
  },
  computed: {
    headers() {
      return [
        {
          text: "資格",
          value: "name",
          sortable: true,
          with: 20
        },
        {
          text: "数量",
          value: "number_of_staffs",
          sortable: false,
          with: 10
        }
      ];
    },
    zz_qualifications() {
      return this.$store.getters['options/options_tables'].zz_qualifications ?? [];
    },
  },
  watch: {
    qualifications_by_work_order: {
      handler: function(newVal) {
        if (!newVal || !newVal.length) return;

        this.setData()
      },
      deep: true,
      immediate: true,
    },
    zz_qualifications: {
      handler: function(newVal) {
        if (!newVal || !newVal.length) return;

        this.setData()
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
<template>
  <div class="mb-2 d-xl-flex">
    <button
      v-b-modal.choose-qualifications
      class="btn btn-primary waves-effect waves-light"
      :disabled="disabled"
    >
      <i class='far fa-list-alt'></i> 資格を選択する
    </button>
    <!-- modal area -->
    <b-modal
      size="lg"
      id="choose-qualifications"
      centered
      title-class="font-18"
      hide-footer
      title="資格一覧"
      scrollable
      @hidden="$emit('modalHidden', 'key_qualifications')"
    >
      <b-row class="mt-2">
        <b-overlay
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="d-inline-block"
        >
          <CommonTableComponent :height-class="`table-wrapper-500`">
            <thead class="table-light">
              <tr>
                <th
                  v-for="(item, index) in headers"
                  :key="index"
                  :class="getHeaderClass(item)"
                >
                  <span>
                    {{ item.text }}
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in qualifications" :key="index">
                <td>
                  {{ item.qualification }}
                </td>
                <td>
                  <b-form-input
                    :id="`qualify_${item.id}`"
                    type="number"
                    class="w-50"
                    v-model="item.number_of_staffs"
                    min="0"
                    :formatter="formatterPositiveNumber"
                  ></b-form-input>
                </td>
              </tr>
              <tr v-if="!qualifications.length">
                <td :colspan="headers.length" class="text-center">
                  データなし。
                </td>
              </tr>
            </tbody>
          </CommonTableComponent>
          <div class="d-flex justify-content-end mt-2">
            <button
              @click="updateValue"
              class="btn btn-primary w-md waves-effect waves-light"
            >
              <i class='fas fa-check'></i> 確定
            </button>
          </div>
        </b-overlay>
      </b-row>
    </b-modal>
  </div>
</template>
